import { getTokenBySymbol as o, getTokenDecimals as d } from "./token.mjs";
import { WalletBase as u, WalletEvents as a } from "../types/index.mjs";
class g extends u {
  // @ts-expect-error, it is temporarily being ignored
  connected;
  address;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ethereum;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accountChangedCallback;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chainChangedCallback;
  constructor() {
    super(), this.ethereum = window.ethereum;
  }
  isSupported() {
    return this.ethereum?.isMetaMask;
  }
  isConnected() {
    return this.connected;
  }
  getAddress() {
    return this.address;
  }
  install() {
    window.open("https://metamask.io/");
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnAccountChangedCallback(e) {
    this.accountChangedCallback = e;
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnChainChangedCallback(e) {
    this.chainChangedCallback = e;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenerCallback(e, t) {
    switch (e) {
      case a.accountsChanged: {
        this.accountChangedCallback != null && this.accountChangedCallback(t[0]);
        break;
      }
      case a.chainChanged: {
        this.chainChangedCallback != null && this.chainChangedCallback(t[0]);
        break;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async connect() {
    if (!this.isSupported())
      this.install();
    else {
      this.ethereum.removeAllListeners(), [
        a.accountsChanged,
        a.chainChanged,
        a.connect,
        a.disconnect,
        a.message
      ].forEach((t) => {
        this.ethereum.on(t, (s) => {
          this.listenerCallback(t, s);
        });
      });
      const e = await this.ethereum.request({
        method: "eth_requestAccounts"
      });
      return (this.address == null || this.address === "") && this.listenerCallback(a.accountsChanged, e), this.address = e[0], this.connected = !0, this.address;
    }
  }
  disconnect() {
    this.address = void 0, this.accountChangedCallback = void 0, this.connected = !1;
  }
  // Send a generic transaction using MetaMask. The data parameter needs to be encoded with ABI for contract method.
  // params: { from, to, data, nonce }
  // @ts-expect-error, it is temporarily being ignored
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async sendTx(e) {
    return await this.ethereum.request({
      method: "eth_sendTransaction",
      params: [e]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
  }
  // Currently has a bug and cannot wait for user selection: https://github.com/MetaMask/metamask-extension/issues/12416
  async addToken(e) {
    const { address: t, image: s, originalSymbol: n } = o(e), c = d(e);
    return await this.ethereum.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          symbol: n,
          address: t,
          decimals: c,
          image: s
        }
      }
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async switchChain(e) {
    const {
      chainId: t,
      chainName: s,
      rpcUrls: n,
      blockExplorerUrls: c,
      nativeCurrency: i,
      iconUrls: l
    } = e;
    try {
      return await this.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: t }]
      });
    } catch (r) {
      if (r.code === 4902)
        try {
          return await this.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: t,
                chainName: s,
                rpcUrls: n,
                blockExplorerUrls: c,
                nativeCurrency: i,
                iconUrls: l
              }
            ]
          });
        } catch (h) {
          console.error(h);
        }
    }
  }
}
export {
  g as default
};
//# sourceMappingURL=metaMask.mjs.map
